import _extends from 'babel-runtime/helpers/extends';

import AutoTips from '@/components/AutoTips/index.vue';
import { getCategoryName } from '../utils';
import { linkageMixin } from '../mixin/linkage';
import { mapState } from 'vuex';
import { gameConfigCategoryResourceType } from '@/store/creative/common/category';
import _ from 'lodash';
import { language } from '@/common/storage';

export default {
  mixins: [linkageMixin],

  components: {
    AutoTips: AutoTips
  },

  props: {
    category: {
      type: Object,
      required: true
    },

    addValidator: {
      type: Function,
      required: true
    },

    updateTargetCategory: {
      type: Function,
      required: true
    },

    editable: {
      type: Boolean,
      default: true
    },

    isDefault: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      editing: false,
      formValue: {},
      disabledToolTip: true,
      desc: ''
    };
  },


  computed: _extends({}, mapState({
    playConfig: function playConfig(state) {
      return state.creative.template.templateConfig.play_config;
    },
    hasPresetResource: function hasPresetResource(state) {
      return state.creative.template.hasPresetResource;
    }
  }), {
    isGameConfigCategory: function isGameConfigCategory() {
      return this.category.resource_type === gameConfigCategoryResourceType;
    },
    titleEditable: function titleEditable() {
      return this.editable;
    },
    tooltipAttrs: function tooltipAttrs() {
      return {
        effect: 'dark',
        placement: 'top',
        content: this.formValue.legend,
        disabled: this.disabledToolTip
      };
    },
    formItemList: function formItemList() {
      var validateName = function validateName(rule, value, callback) {
        if (value.length >= 100) {
          callback(new Error('category name length must lt 100'));
        } else {
          callback();
        }
      };

      return {
        legend: {
          prop: 'legend',
          rules: [{
            required: true,
            message: 'category name is required',
            trigger: 'blur'
          }, {
            required: true,
            validator: validateName,
            trigger: 'blur'
          }],
          params: {
            clearable: false
          },
          style: 'margin-bottom: 0'
        }
      };
    }
  }),

  watch: {
    editing: function editing(val) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.$refs.input && _this.$refs.input.focus();
        }, 100);
      } else {
        this.$nextTick(function () {
          _this.checkIsShowTip();
        });
      }
    },


    // 保证切换的时候会更新name
    'category.id': function categoryId(val) {
      this.getFormValue();
    },
    'category.name': function categoryName(val) {
      this.getFormValue();
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$refs.form && _this2.$refs.form.validate && _this2.addValidator({
        name: 'group-legend',
        validate: _this2.$refs.form.validate
      });
    });
    this.getFormValue();
  },


  methods: {
    handleBlur: function handleBlur(evt) {
      var _this3 = this;

      if (evt.target.value === this.category.name) {
        this.editing = false;
        return;
      }
      this.updateTargetCategory({
        name: evt.target.value,
        id: this.category.id
      });
      // 只有校验通过才隐藏输出框
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this3.editing = false;
        }
      });
    },
    checkIsShowTip: function checkIsShowTip() {
      if (this.$refs.labelText.offsetWidth > 180) {
        this.disabledToolTip = false;
      } else {
        this.disabledToolTip = true;
      }
    },
    getFormValue: function getFormValue() {
      var getGameConfigCategoryDesc = function getGameConfigCategoryDesc(category) {
        return language.get() === 'en' ? category.desc_en || category.desc : category.desc;
      };
      var currentGameConfigConfig = _.get((this.playConfig || {}).gameConfig, '[' + this.category.prefix + ']');
      // 先从 playConfig 中获取，如果没有，则从 category 中获取
      // name 也同理
      var desc = currentGameConfigConfig && getGameConfigCategoryDesc(currentGameConfigConfig) || getGameConfigCategoryDesc(this.category);
      if (this.isGameConfigCategory) {
        this.formValue = {
          legend: getCategoryName(this.category),
          desc: desc
        };
      } else {
        this.formValue = {
          legend: getCategoryName(this.category)
        };
      }
    },
    handleDescChange: function handleDescChange(val) {
      this.updateTargetCategory({
        desc: val,
        id: this.category.id
      });
    }
  }
};